import {createSelector} from "reselect";

import * as StepLabels from "../constants/StepLabels";
import {faCogs} from "@fortawesome/pro-light-svg-icons/faCogs";
import {faGlobe} from "@fortawesome/pro-light-svg-icons/faGlobe";
import {faUser} from "@fortawesome/pro-light-svg-icons/faUser";
import {faCreditCardFront} from "@fortawesome/pro-light-svg-icons/faCreditCardFront";
import {faClipboardListCheck} from "@fortawesome/pro-light-svg-icons/faClipboardListCheck";
import {getArticleOptionsInCartList} from "./CartUtil";
import {isMode} from "./Mode";
import {APP_MODE_ACCESSORY, APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_AUTHENTICATED_ORDER, APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE, OUTSOURCING_CREATE_NEW, PROJECT_TYPE_SKIP} from "../constants/General";
import {faCompressAlt} from "@fortawesome/pro-light-svg-icons/faCompressAlt";
import {getBaseArticle, getCartAllowedForCustomerChange, getToggleSelections} from "./SimpleSelectors";
import {agencyServerArticleNumber, agencyServerProjectArticles} from "../config/Config";
import {faBoxes} from "@fortawesome/pro-light-svg-icons/faBoxes";
import {getCurrentProduct} from "./ProductSelection";
import {isNonUsualArticleType} from "./ArticleNumbers";

export const isExistingUserAuthenticatedAndSelected = state => state && state.clientDataStep && state.clientDataStep.existingUserAuthenticated && state.clientDataStep.existingCustomerSelected;

// **************************************************************************************************************
export const getStepOrder = createSelector(
    [
        isExistingUserAuthenticatedAndSelected,
        getArticleOptionsInCartList,
        getToggleSelections,
        getCurrentProduct,
        getBaseArticle,
        getCartAllowedForCustomerChange
    ],
    (
        existingUserAuthenticatedAndSelected,
        articleOptionsInCartList,
        toggleSelections,
        currentProduct,
        baseArticle,
        isAllowedForCustomerChange
    ) => {

        if (isMode(APP_MODE_PRODUCT_CHANGE)) {

            if (agencyServerProjectArticles.indexOf("" + currentProduct) >= 0) {
                return [
                    StepLabels.PRODUCT_CHANGE,
                    StepLabels.SUMMARY
                ]
            } else {
                return [
                    StepLabels.PRODUCT_CHANGE,
                    StepLabels.SUMMARY
                ]
            }

        } else if (isMode(APP_MODE_OUTSOURCING)) {

            // always logged in

            if (toggleSelections && toggleSelections["outsourcingTarget"] === OUTSOURCING_CREATE_NEW) {
                return [
                    StepLabels.OUTSOURCING_TARGET,
                    StepLabels.OUTSOURCING_RECOMMEND
                ]
            } else {
                return [
                    StepLabels.OUTSOURCING_TARGET,
                    StepLabels.SUMMARY
                ]
            }


        } else if (isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT)) {

            // always logged in

            if (articleOptionsInCartList.indexOf("696969") >= 0) {

                // hide domains when dev account selected

                return [
                    StepLabels.CONFIG,
                    StepLabels.SUMMARY
                ]

            } else {

                return [
                    StepLabels.CONFIG,
                    StepLabels.DOMAIN,
                    StepLabels.SUMMARY
                ]

            }


        } else if (isMode(APP_MODE_ACCESSORY)) {

            return [
                StepLabels.SUMMARY
            ]

        } else {

            let stepConfig;

            if (isMode(APP_MODE_AUTHENTICATED_ORDER)) {
                stepConfig = [StepLabels.PRODUCT_SELECTION];
            } else {
                stepConfig = [];
            }

            let includeDomainStep = true;
            let includeConfigStep = true;

            if (baseArticle && (baseArticle.articleNumber + '') === agencyServerArticleNumber && toggleSelections && toggleSelections["projectConfiguration"] === PROJECT_TYPE_SKIP) {
                // skip domain step if project is skipped
                includeDomainStep = false;
            }

            if (baseArticle && isNonUsualArticleType(baseArticle.type)) {
                includeDomainStep = false;
                includeConfigStep = false;
            }

            if (isAllowedForCustomerChange) {
                includeDomainStep = false;
            }

            if (includeConfigStep) {
                stepConfig.push(StepLabels.CONFIG);
            }

            if (includeDomainStep) {
                stepConfig.push(StepLabels.DOMAIN);
            }

            if (!isMode(APP_MODE_AUTHENTICATED_ORDER)) {
                stepConfig.push(StepLabels.CLIENTDATA);
            }

            if (!existingUserAuthenticatedAndSelected) {
                stepConfig.push(StepLabels.PAYMENT);
            }

            stepConfig.push(StepLabels.SUMMARY);

            return stepConfig;

        }

    })


// **************************************************************************************************************
export const getStepLabelWording = () => {

    return {
        [StepLabels.PRODUCT_CHANGE]: {title: "Tarifauswahl", icon: faBoxes},
        [StepLabels.PRODUCT_SELECTION]: {title: "Tarifauswahl", icon: faBoxes},
        [StepLabels.OUTSOURCING_TARGET]: {title: "Ziel", icon: faCompressAlt},
        [StepLabels.OUTSOURCING_CONFIG]: {title: "Konfiguration", icon: faCogs},
        [StepLabels.OUTSOURCING_AGENCY]: {title: "Konfiguration", icon: faCogs},
        [StepLabels.OUTSOURCING_RECOMMEND]: {title: "Bestellübersicht", icon: faClipboardListCheck},
        [StepLabels.CONFIG]: {title: "Konfiguration", icon: faCogs},
        [StepLabels.DOMAIN]: {title: "Domainauswahl", icon: faGlobe},
        [StepLabels.CLIENTDATA]: {title: "Vertragspartner", icon: faUser},
        [StepLabels.PAYMENT]: {title: "Zahlungsart", icon: faCreditCardFront},
        [StepLabels.SUMMARY]: {title: "Bestellübersicht", icon: faClipboardListCheck},
        [StepLabels.ACCESSORY_ADD]: {title: "Bestellübersicht", icon: faClipboardListCheck},
    }

}

export const getLabeledStepOrder = createSelector(
    [getStepOrder],
    (order) => {
        let mapStepsToLabel = {}

        order.forEach((stepOrderEntry) => {
            mapStepsToLabel[stepOrderEntry] = getStepLabelWording()[stepOrderEntry]
        })

        return mapStepsToLabel
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/UserInterface.js
 **/